export const reportSalesByNoteTypes = {
  SET_SALES_BY_NOTE_FILTERS: 'SET_SALES_BY_NOTE_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
